import { css, SerializedStyles } from '@emotion/react';

export const STATIC_STYLES: SerializedStyles = css`
    // Outer grid
    display: grid;
    grid-template-columns: 1fr;
    gap: calc(var(--hc-spacing-unit) * 2);

    // inner grid template
    [data-grid-template] {
        display: grid;
        gap: calc(var(--hc-spacing-unit) * 2);
    }

    [data-image-slot] {
        position: relative;
        background: rgba(0, 0, 0, 0.1);

        &:where([data-shape='square']) {
            aspect-ratio: 1 / 1;
        }

        &:where([data-shape='portrait']) {
            aspect-ratio: 3 / 4;
        }

        &:where([data-shape='landscape']) {
            aspect-ratio: 3 / 2;
        }

        &:where([data-shape='banner']) {
            aspect-ratio: 2 / 1;
        }

        // Overlay mask displayed on hover and keyboard focus
        &::after {
            content: '';
            position: absolute;
            inset: 0;
            background-color: #000;
            opacity: 0;
            transition: opacity 0.2s ease;
            pointer-events: none;
        }

        &:hover::after,
        &:focus-visible::after {
            opacity: 0.1;
        }
    }

    [data-image] {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
